import { Box, Typography } from '@mui/material';
import classNames from 'classnames';
import React, { FC, ReactElement } from 'react';
import { useStyles } from './TournamentAlert.styles';

interface TournamentAlertProps {
  title: string;
  description?: string;
  direction?: 'row' | 'column';
  controls?: ReactElement | null;
}

export const TournamentAlert: FC<TournamentAlertProps> = ({
  title,
  description,
  direction = 'row',
  controls,
}) => {
  const { classes } = useStyles();

  if (!title) {
    return null;
  }

  return (
    <Box className={classNames(classes.root, [classes[direction]])}>
      <Box>
        <Typography className={classes.title}>{title}</Typography>
        {description && <Typography className={classes.description}>{description}</Typography>}
      </Box>
      {controls}
    </Box>
  );
};
